import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) { }

  fetchEvents(): Observable<any> {
    const obj = {};
    return this.http.post<any>(environment.xdeBackendURL + '/v1/get_partnersmeet_details', obj).pipe(
      catchError(this.handleError)
    );
  }

  fetchEventData(id: any): Observable<any> {
    const obj = {
      event_id: id
    };
    return this.http.post<any>(environment.xdeBackendURL + '/v1/get_cp_activity_details', obj).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred';

    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Network Error: ${error.error.message}`;
    } else {
      // Backend returned an unsuccessful response code
      if (error.status === 0) {
        errorMessage = 'Unable to reach the server. Please check your connection and ensure CORS is properly configured on the backend.';
      } else {
        errorMessage = `Server Error ${error.status}: ${error.statusText}\n${error.error?.message || 'No additional details'}`;
      }
    }

    console.error('API Error:', {
      status: error.status,
      statusText: error.statusText,
      message: errorMessage,
      url: error.url
    });

    return throwError(() => new Error(errorMessage));
  }
}
